import { useSelector } from 'react-redux';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import type { QualityIssue } from '../../../../../shared/issuesV2';
import styles from '../IssueContent.module.less';
import { Badge } from '../../../generic';
import { QUALITY_ISSUE_CONFIG } from '../../../../shared/issuesV2/issueConfig';
import PackageLocator from '../../../shared/issues/PackageLocator';

/**
 * Renders a header for quality issues.
 *
 * Displays:
 * - A badge representing the issue type.
 * - The title of the issue.
 * - A package locator, if available.
 */
const Header = () => {
  const issueDetails = useSelector(IssuesV2Store.selectors.getIssueDetails) as QualityIssue;
  const issueType = useSelector(IssuesV2Store.selectors.getQualityIssueType);
  const locatorParts = useSelector(IssuesV2Store.selectors.getIssueDetailsSourceLocatorParts);
  // Avoiding selectors due to .less imports not supported by unit tests.
  const title = QUALITY_ISSUE_CONFIG[issueType]?.title ?? 'Unknown';

  if (!issueDetails) {
    return null;
  }

  return (
    <header className={styles.header}>
      <div className={styles.headerBadge}>
        <Badge
          color={QUALITY_ISSUE_CONFIG[issueDetails.type]?.color}
          icon={QUALITY_ISSUE_CONFIG[issueDetails.type]?.icon}
          fullWidth
        >
          {QUALITY_ISSUE_CONFIG[issueDetails.type]?.label}
        </Badge>
      </div>
      <div className={styles.heading}>
        {title}
      </div>
      {locatorParts && (
        <PackageLocator
          locatorParts={locatorParts}
          isPrefixDisplayed
        />
      )}
    </header>
  );
};

export default Header;
